import { Injectable } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from 'angularfire2/firestore';
import {Swapstations} from '../pages/layout/list-swapstations/list-swapstations.component';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { pipe } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { API_ENDPOINTS } from './api-endpoints';


@Injectable({
  providedIn: 'root'
})
export class SwapstationsService {

  orgUrl = "";

  constructor(private afs: AngularFirestore,
    private http: HttpClient) { }

  getSwapstations() {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.SwapStationCollection).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data();
        const id = action.payload.doc.id;
        return { id, data };
      });
    });
  }

  
  addSwapStation(data) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return new Promise<any>((resolve, reject) =>{
      this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.SwapStationInfoMap).add(data).then(res => {
        resolve(res);
      }, err => reject(err));
  });
  }


  callfunction(){
    // const swapstationDevicesRef = this.afs.collection('devices');
    // const organizationRef = this.afs.collection('Batterypool');
    // swapstationDevicesRef.get().toPromise().then((snapshot) => {
    //     const currentTimestamp = Math.round((new Date()).getTime() / 1000)
    //     snapshot.docs.forEach(doc => {
    //         const deviceIMEI=doc.id;
    //         swapstationDevicesRef.doc(deviceIMEI).collection('SwapStn').doc('Status').get().toPromise().then(function(statusDoc) {
    //             try {
    //                 // console.log("doc Id: " + doc.id)
    //                 // console.log("online: " + statusDoc.data().online)
    //                 const swapstationStateMap = statusDoc.data().state;
    //                 const lastDataTimestampObj = swapstationStateMap['timeStamp'];
    //                 console.log("lastDataTimestampin seconds from firestore: " + lastDataTimestampObj)
    //                 console.log("lastDataTimestampin seconds from firestore: " + lastDataTimestampObj.seconds)
    //                 const lastDataTimestamp = lastDataTimestampObj.seconds

    //                 console.log("lastDataTimestamp: " + lastDataTimestamp)
    //                 console.log("currentTimestamp: " + currentTimestamp)
    //                 const diffInSeconds = Math.abs(currentTimestamp - lastDataTimestamp)
    //                 console.log(deviceIMEI+" diff in seconds: " + diffInSeconds)
    //                 if (diffInSeconds < 35) {
    //                     organizationRef.get().toPromise().then((snapshot) => {
    //                         snapshot.docs.forEach(orgDoc => {
    //                             // console.log("organization ID: "+orgDoc.id)
    //                             const orgId=orgDoc.id
    //                             organizationRef.doc(orgId).collection("SwapStationInfoMap",ref => ref.where('IMEI', '==', deviceIMEI)).get().toPromise().then((snapshotSwapStationInfoMapDocs) => {
                                    
    //                                 snapshotSwapStationInfoMapDocs.docs.forEach(snapshotSwapStationInfoMapDoc => {
    //                                     console.log("snapshotSwapStationInfoMapDoc ID: "+snapshotSwapStationInfoMapDoc.id)
    //                                     organizationRef.doc(orgId).collection("SwapStationInfoMap").doc(snapshotSwapStationInfoMapDoc.id).set({
    //                                         online: "true"
    //                                     }, {

    //                                         merge: true
    //                                     }).then(function() {
    //                                         console.log("status of docId: " + deviceIMEI + "set to true!")
    //                                     }).catch(function(error) {
    //                                         console.error("Error writing", error);
    //                                     });

    //                                 })

    //                             });
    //                         });
    //                     });


    //                 } else {
    //                     console.log("greater thatn 35" + doc.id)
    //                     // organizationRef.get().then((snapshot) => {
    //                     //      snapshot.docs.forEach(orgDoc => {
    //                     //          organizationRef.doc(orgDoc.id).collection("SwapStationInfoMap").where('IMEI', '==', doc.id).add({
    //                     //     online: "true"
    //                     // }).then(function() {
    //                     //     console.log("status of docId: "+doc.id +"set to false!")
    //                     // }).catch(function(error) {
    //                     //     console.error("Error writing", error);
    //                     // });
    //                     //      });
    //                     // });

    //                       organizationRef.get().toPromise().then((snapshot) => {
    //                         snapshot.docs.forEach(orgDoc => {
    //                             // console.log("organization ID: "+orgDoc.id)
    //                             const orgId=orgDoc.id
    //                             organizationRef.doc(orgId).collection("SwapStationInfoMap",ref => ref.where('IMEI', '==', deviceIMEI)).get().toPromise().then((snapshotSwapStationInfoMapDocs) => {
    //                                 console.log(snapshotSwapStationInfoMapDocs.size)
    //                                 snapshotSwapStationInfoMapDocs.docs.forEach(snapshotSwapStationInfoMapDoc => {
    //                                     console.log("snapshotSwapStationInfoMapDoc ID: "+snapshotSwapStationInfoMapDoc.id)
    //                                     organizationRef.doc(orgId).collection("SwapStationInfoMap").doc(snapshotSwapStationInfoMapDoc.id).set({
    //                                         online: "false"
    //                                     }, {

    //                                         merge: true
    //                                     }).then(function() {
    //                                         console.log("status of docId: " + deviceIMEI + "set to false!")
    //                                     }).catch(function(error) {
    //                                         console.error("Error writing", error);
    //                                     });

    //                                 })

    //                             });
    //                         });
    //                     });
    //                 }
    //             } catch(err) {
    //                 console.log("timestamp doesn't exist "+err.message)
    //             }
    //         });
    //     })
    // })
  }

  getSwapstationsold(){
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection<Swapstations>(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.SwapStationInfoMap).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Swapstations;
        const id = action.payload.doc.id;
        // console.log(id)
        return { id, ...data };
      });
    });
  }

  async getAllStationsData() {
    return await new Promise((resolve, reject) => {
      axios.request({
        method: 'get',
        url: `${API_ENDPOINTS.general.getAllStationsData}`,
      })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }

  getEvList() {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.ChargePointCollection).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Swapstations;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });
  }

  AddSwapstationInfoInSwapStationList(data,id) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return new Promise<any>((resolve, reject) =>{
      this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.SwapStationCollection).doc('swapStationListMap').
      set({'swapStationMap':{[id]:data}},{merge:true}).then(res => { }, err => reject(err));
    });
   }

  getParticularSwapstationInfo(docId){
    this.orgUrl = localStorage.getItem('currentOrganisation');
    if(typeof docId !== 'undefined'){
      return this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.SwapStationInfoMap).doc(docId).snapshotChanges().pipe(map(action => {
        const data = action.payload.data();
        const id = action.payload.id;
        return { id, ...data };
      }));
    }
  }
  
  editSwapstationInfo(data,id) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return new Promise<any>((resolve, reject) =>{
      this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.SwapStationInfoMap).doc(id).update(data).then(res => {}, err => reject(err));
  });
 }

 updateSwapStnDoor(door_array, door_no,id) {
  //NOTE-NUMBER OF DOORS IN POWERHIVE AND BATTERYPOOL SWAPSTATION ARE DIFFERENT THEREFORE door_array is initialized in if else
  let updatedDoorArray=[...door_array];
  // let refreshDoorArray=[...door_array]
  updatedDoorArray[door_no] = 1;

  this.afs.doc('/devices/'+id.toString()).update({'state.door_status':[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]}).then(res =>{
    this.afs.doc('/devices/'+id.toString()).update({'state.door_status':updatedDoorArray});
    this.afs.collection(environment.env.EnvBaseUrl+'/DashSwapstationModuleClicks/').add({imei: id.toString(), timestamp: new Date(),  commandType: "door", updatedDoorArray: updatedDoorArray});
  }).catch(err => {
    // console.log('something went wrong '+ err)
  });

}

 updateChargerStatus(chargerStatusList, door_no,id) {
  let OldChargerStatus=[...chargerStatusList]
  let updatedChargerStatus=[...chargerStatusList]
  if(updatedChargerStatus[door_no] == 0){
    updatedChargerStatus[door_no] = 1;
  } else {
    updatedChargerStatus[door_no] = 0;
  }
  this.afs.doc('/devices/'+id.toString()).update({'state.charger_status':OldChargerStatus}).then(res =>{
    this.afs.doc('/devices/'+id.toString()).update({'state.charger_status':updatedChargerStatus});
    this.afs.collection(environment.env.EnvBaseUrl+'/DashSwapstationModuleClicks/').add({imei: id.toString(), timestamp: new Date(), commandType: "charger", oldChargerArray:OldChargerStatus, updatedChargerStatus: updatedChargerStatus});
  }).catch(err => {
    // console.log('something went wrong '+ err)
  });
}
  assignBattery(JSONobj){
    let httpBody = {}
    httpBody=JSONobj
    return this.http.post<any>("https://prod-api-v1.batterypool.com/api/swapStation/resetBatteryDoor",httpBody).map(res=>{
    return res;
   });
  }


 editSwapstationInfoInSwapStationList(data,id) {
  this.orgUrl = localStorage.getItem('currentOrganisation');
  return new Promise<any>((resolve, reject) =>{
    this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.SwapStationCollection).doc('swapStationListMap').
    set({'swapStationMap':{[id]:data}},{merge:true}).then(res => { }, err => reject(err));
  });
 }
 
}
